import React from 'react';
import post from "../assets/images/schedule.png";
import user from "../assets/images/user.png";
import insta from '../assets/icons/insta.svg';
import DotMenu from './DotMenu';
import { IoSettingsOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { CalendarIcon, ClipboardIcon } from '../assets/icons/Icons';

const options = [
  { label: 'Edit parameters', icon: IoSettingsOutline },
  { label: 'Unschedule post', icon: RxCross2, color: "red" },
];

const ScheduledPostCard = () => {
  return (
    <div className="w-[379px] h-[110px] rounded-xl bg-white flex items-center gap-2">
      <img src={post} className="w-[93px] h-[102px] m-1 inline-block" alt="post" />
      <div className="w-full py-3 pr-3">
        <div className="flex justify-between">
          <p className="text-[#0F0C18] text-base font-medium tracking-tight">Another video</p>
          <DotMenu options={options} type="normal" md />
        </div>
        <div className="flex items-center gap-[6px] mt-[6px]">
        <div className="flex items-center">
            <img src={user} className="w-4 h-4 rounded-full -mr-[5px] z-20" alt="user" />
            <img src={insta} className="w-4 h-4 rounded-full z-30" alt="workspace" />
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">@andrew_wack</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-[6px]">
            <CalendarIcon />
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">Scheduled for</div>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">12:34 / 23 Jul 2024</p>
        </div>  
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-[6px]">
            <ClipboardIcon />
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">Content type</div>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Instagram reels</p>
        </div>
      </div>
    </div>
  );
};

export default ScheduledPostCard;